import Splide from '@splidejs/splide'

const allPublishersSlider = () => {
  const sliders = document.querySelectorAll('.js-all-publishers-slider')

  if (!sliders.length) {
    return
  }

  sliders.forEach((slider) => {
    const container = slider.closest('.all-publishers')
    const prevButton = container.querySelector('.js-all-publishers-prev')
    const nextButton = container.querySelector('.js-all-publishers-next')

    const splide = new Splide(slider, {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      autoWidth: true,
      gap: '16px',
      arrows: false,
      pagination: false,
    })

    const updateArrows = () => {
      const index = splide.index
      const end = splide.Components.Controller.getEnd()

      if (prevButton) {
        prevButton.classList.toggle('is-active', index > 0)
      }

      if (nextButton) {
        nextButton.classList.toggle('is-hidden', index >= end)
      }
    }

    splide.on('mounted moved', updateArrows)
    splide.mount()

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        splide.go('-1')
      })
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        splide.go('+1')
      })
    }
  })
}

export default allPublishersSlider
